.field {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.label {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-secondary);
}

.hint {
  margin: 0;
  font-size: 0.8125rem;
  color: var(--text-muted);
}

.box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  min-height: 48px;
  padding: 4px 10px;
  background: var(--bg-elevated);
  border: 1px solid var(--border-primary);
  cursor: text;
}

.box:hover {
  border-color: var(--text-muted);
}

.box:focus-within {
  border-color: var(--accent);
}

.input {
  flex: 1;
  min-width: 120px;
  min-height: 38px;
  padding: 0 4px;
  font: inherit;
  color: var(--text-primary);
  background: transparent;
  border: 0;
  outline: 0;
}

.input::placeholder {
  color: var(--text-muted);
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 4px 3px 10px;
  font-size: 0.875rem;
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
}

.chip button,
.clear {
  display: inline-grid;
  place-items: center;
  width: 22px;
  height: 22px;
  font: inherit;
  color: var(--text-secondary);
  background: transparent;
  border: 0;
  cursor: pointer;
}

.chip button:hover,
.clear:hover {
  color: var(--accent-text);
}

.list {
  position: absolute;
  z-index: 70;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 280px;
  margin: 2px 0 0;
  padding: 4px 0;
  overflow-y: auto;
  list-style: none;
  background: var(--bg-elevated);
  border: 1px solid var(--border-primary);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4);
}

.option {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 8px 14px;
  cursor: pointer;
}

.option[aria-selected='true'] {
  color: var(--accent-text);
}

.active {
  background: var(--bg-secondary);
}

.sub {
  font-size: 0.8125rem;
  color: var(--text-muted);
}

.empty {
  padding: 10px 14px;
  color: var(--text-muted);
}
